import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-required-indicator',
  template: `
    <span class="required-indicator">*</span>`
})
export class RequiredIndicatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
